import { create } from "zustand";
import { persist } from "zustand/middleware";

export const BRANDING_STATUS = Object.freeze({
  IDLE: "idle",
  LOADING: "loading",
  READY: "ready",
  ERROR: "error",
});

export const BRANDING_STORE_VERSION = 2;

const initialBrandingState = {
  preLogin: null,
  postLogin: null,
  preLoginStatus: BRANDING_STATUS.IDLE,
  postLoginStatus: BRANDING_STATUS.IDLE,
  preLoginError: null,
  postLoginError: null,
};

const useBrandingStore = create(
  persist(
    (set) => ({
      ...initialBrandingState,

      setPreLoginBranding: (payload) => set({
        preLogin: payload ?? null,
        preLoginStatus: BRANDING_STATUS.READY,
        preLoginError: null,
      }),
      setPostLoginBranding: (payload) => set({
        postLogin: payload ?? null,
        postLoginStatus: BRANDING_STATUS.READY,
        postLoginError: null,
      }),
      setPreLoginStatus: (status, error = null) => set({
        preLoginStatus: status,
        preLoginError: error,
      }),
      setPostLoginStatus: (status, error = null) => set({
        postLoginStatus: status,
        postLoginError: error,
      }),
      resetPostLogin: () => set({
        postLogin: null,
        postLoginStatus: BRANDING_STATUS.IDLE,
        postLoginError: null,
      }),
      resetAllBranding: () => set(initialBrandingState),
    }),
    {
      name: "branding-store",
      partialize: (state) => ({
        preLogin: state.preLogin,
        postLogin: state.postLogin,
      }),
      version: BRANDING_STORE_VERSION,
      migrate: (persistedState, version) => {
        // Version 1 stored the retired camelCase mock contract. It cannot be
        // mixed with the backend's snake_case API contract.
        if (version < BRANDING_STORE_VERSION) {
          return { preLogin: null, postLogin: null };
        }
        return persistedState;
      },
    }
  )
);

export const usePreLoginBrandingPayload = () => useBrandingStore((s) => s.preLogin);
export const usePostLoginBrandingPayload = () => useBrandingStore((s) => s.postLogin);
export const usePreLoginBrandingStatus = () => useBrandingStore((s) => s.preLoginStatus);
export const usePostLoginBrandingStatus = () => useBrandingStore((s) => s.postLoginStatus);

export default useBrandingStore;
